import { Stack } from "@mui/material";
import { AppleButton } from "Components/Auth/Apple/AppleButton";
import { GoogleButton } from "Components/Auth/Google/GoogleButton";

type Props = {
  isLoading: boolean;
  affiliateCode?: string;
};

export const AuthButtons = ({ isLoading, affiliateCode }: Props) => (
  <Stack gap={2}>
    <GoogleButton isLoading={isLoading} affiliateCode={affiliateCode} />
    <AppleButton isLoading={isLoading} affiliateCode={affiliateCode} />
  </Stack>
);
